import { Collection } from 'modules/core/lib/mobx-rest'

import OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'

class OverlapPeriods extends Collection<OverlapPeriod> {
  get cacheKey(): string {
    return 'overlapPeriods'
  }

  model() {
    return OverlapPeriod
  }
}

const singleton: OverlapPeriods = new OverlapPeriods()

export default singleton
